import React, { useState, useEffect, useRef } from 'react'
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux'
import axios from 'axios'
import { FormattedMessage  } from 'react-intl';

import LoadingControl from './Loading';
import { PRINTERS_PATH, USERS_PATH, COMPUTERS_PATH, DOCUMENTS_PATH } from '../utils/constants';
import { getCurrencySymbol, formatBytes } from '../utils/utils';
import {ApplyFilterParams} from '../utils/ApplyFilterParams'
import DescriptionObject from './DescriptionObject';
import DocumentsTable from './DocumentsTable';
import ChartDistribution from './ChartDistribution';
import { GetMostActiveColumns } from './GetMostActiveObjectsColumn';
import MostActiveObjectsTable from './MostActiveObjectsTable';

const UserReportGeneral = (props) => {
    const [state, setState] = useState({
        error: null,
        isLoaded: false,
        user: null
    });

    let filterData = useSelector(state => state.reportFilter);

    async function getData() {

        var url = ApplyFilterParams("/user/" + props.userId + "?doNotReturnEmptyObjects=false", filterData);
        
        const res = await axios(url);
        return res.data;
        }

    useEffect(() => {
        if (props.userId)
        {
            setState( {error: {message : "Bad user id"}});
        }
        setState({isLoaded: false});
    
        getData()
        .then(res => {
            setState({ error: null, isLoaded: true, user: getColumns(res) });
        })
        .catch(err => {
            setState( {error: err, isLoaded: false, user: null });
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.userId, filterData]);    


    let daysNumber = useRef();

    function getColumns(res)
    {
        const lang = navigator.language || navigator.userLanguage;

        var data = [];
        if ((res instanceof Array) && res.length > 0)
        {
            data = data = res[0];
        }

        let dateMin = new Date(data.minDate);
        let dateMax = new Date(data.maxDate);

        let reportPeriod = "";
        if (isNaN(dateMin) || isNaN(dateMax))
        {
            daysNumber.current = null;
        }
        else
        {
            daysNumber.current = Math.round(dateMax.getTime() - dateMin.getTime()) / (1000 * 60 * 60 * 24);

            reportPeriod = dateMin.toLocaleDateString(lang) + ' - ' + 
                    dateMax.toLocaleDateString(lang);

        }

        const formatConfig = {
            style: 'currency',
            currency: getCurrencySymbol(navigator.language || navigator.userLanguage),
            minimumFractionDigits: 2,
            currencyDisplay: 'symbol',
        };

        const currencyFormatter = new Intl.NumberFormat(navigator.language || navigator.userLanguage, formatConfig);

        var columns = [
            {
                title :  <FormattedMessage id="User"/>,
                data : data.userName,
            },
            {
                title : <FormattedMessage id="Printers"/>,
                data : data.printers,
                link: PRINTERS_PATH + "?userId=" + props.userId,
            },
            {
                title : <FormattedMessage id="Computers"/>,
                data : data.computers,
                link: COMPUTERS_PATH + "?userId=" + props.userId,
            },
            {
                title : <FormattedMessage id="Report.PrintedJobs"/>,
                data : data.documents,
                link: DOCUMENTS_PATH + "?userId=" + props.userId,
            },
            {
                title : <FormattedMessage id="Pages"/>,
                data : data.pages,
            },
            {
                title : <FormattedMessage id="Cost"/>,
                data : currencyFormatter.format(data.cost === undefined ? 0 : data.cost),
            },
            {
                title : <FormattedMessage id="JobDataSize"/>,
                data : formatBytes(data.jobDataSize === undefined ? 0 : data.jobDataSize),
            },
            {
                title : <FormattedMessage id="ReportPeriod"/>,
                data : reportPeriod,
            },
        ];

        return columns;
    }


        if(state.error != null)
        {
            return (
                <div>
                    <h3>{state.error.message}</h3>
                    <Link to={USERS_PATH}><FormattedMessage id="Back"/></Link>
                </div>
            );
        }
        else if (!state.isLoaded)
        {
            return (
                <div><LoadingControl/></div>
            );
        }
        else
        {          
            if (state.user === null)
            {
                return ( 
                    <div>
                        <FormattedMessage id="ObjectNotFound"/>
                        <Link to={USERS_PATH}><FormattedMessage id="Back"/></Link>
                    </div>
                );
            }
            
            return (
            <div>
                <div className = "description-parent">
                    <div className = "description-object"><DescriptionObject object = {state.user}/></div>
                    <div className = "description-object"><ChartDistribution object_id = {'userId=' + props.userId}/></div>
                </div>
                <br/>
                <br/>
                <h4><FormattedMessage id="LastDocuments"/></h4>
                <DocumentsTable parent_id_param = {'?userId=' + props.userId} 
                                api_url = {ApplyFilterParams('job?maxCount=20&userId=' + props.userId, filterData)}/>
                <h4><FormattedMessage id="MostActivePrinters"/></h4>
                <MostActiveObjectsTable 
                    parent_id_param = {'?userId=' + props.userId} 
                    api_url = {ApplyFilterParams('printer_ex?noStats=false&returnEmpty=false&sort=Documents%20DESC&maxCount=10&userId=' + props.userId, filterData)}
                    get_columns = {GetMostActiveColumns(PRINTERS_PATH, '?userId=' + props.userId , daysNumber.current)}

                />
                <h4><FormattedMessage id="MostActiveComputers"/></h4>
                <MostActiveObjectsTable 
                    parent_id_param = {'?userId=' + props.userId} 
                    api_url = {ApplyFilterParams('computer?noStats=false&returnEmpty=false&sort=Documents%20DESC&maxCount=10&userId=' + props.userId, filterData)}
                    days_number = {daysNumber.current}
                    get_columns = {GetMostActiveColumns(COMPUTERS_PATH, '?userId=' + props.userId, daysNumber.current)}
                />
            </div>
            )
        }    
}

export default UserReportGeneral;